import { mount, TagInstance } from 'riot';
import { getRawQueryParams } from '../../services/queryParams';
import landRegistryStore from '../../stores/landRegistry';
import * as tagStatesMixin from '../tagStatesMixin';
import * as landRegistryConstants from '../../constants/landRegistry';

const { events: landRegistryEvents } = landRegistryConstants;

const getTextItemClasses = (textItem: any): string => {
  let classes = '';

  if (textItem.bold === true) {
    classes += 'ambita-bold ';
  }

  if (textItem.alignment === 'right') {
    classes += 'ambita-landregistry-right__details-align-right';
  } else {
    classes += 'ambita-landregistry-right__details-align-left';
  }

  return classes;
};

const setNestingSymbol = (nestingLevel: number): string => {
  return Array(nestingLevel + 1).join('** ');
};

export const init = (tag): void => {
  let orderTag: TagInstance;

  tag.mixin(tagStatesMixin);

  const createOrderData = (): any => {
    let document = '';
    const right = tag.right;

    if (right.documentCode) {
      document = right.documentCode.text.toString();
    } else if (right.documentType) {
      document = right.documentType.text.toString();
    }

    return {
      knr: tag.opts.knr ? tag.opts.knr.toString() : '0000',
      dokument: document,
      doknr: right.ident.documentNumber.toString(),
      aar: right.ident.documentYear.toString(),
      embetsnummer: right.ident.office.toString()
    };
  };

  const updateState = (): void => {
    const right = landRegistryStore.getRight();
    tag.status = right.status;

    if (right.data && right.data.item) {
      tag.right = right.data.item;
    }

    tag.update();
  };

  const mountPantebokOrder = (orderReference: string): void => {
    if (orderTag) {
      orderTag.update({
        reference: orderReference
      });
    } else {
      const orderData = createOrderData();
      const reference = orderReference;
      const purchaseAllowed = tag.right.documentCopyExists;
      const tagToMount = tag.root.querySelector(`[right-key='${tag.right.key}']`);
      orderTag = mount(tagToMount, 'ambita-pantebok-order', {
        orderData,
        reference,
        purchaseAllowed
      })[0];
    }
  };

  const setReference = (orderReference?: string): void => {
    if (orderReference) {
      mountPantebokOrder(orderReference);
    } else {
      const query = getRawQueryParams();
      if (query.reference) {
        mountPantebokOrder(query.reference);
      }
    }
  };

  tag.getTextItemClasses = getTextItemClasses;
  tag.nestingSymbol = setNestingSymbol;

  tag.on('mount', () => {
    if (!tag.hasOwnProperty('right')) {
      tag.showHistoricLines = true;

      updateState();
      landRegistryStore.subscribe(updateState);
    } else {
      landRegistryStore.on(landRegistryEvents.SET_ORDER_REFERENCE, setReference);
      setReference(landRegistryStore.getState().orderReference);
    }
  });

  tag.on('unmount', () => {
    if (!tag.hasOwnProperty('right')) {
      landRegistryStore.unsubscribe(updateState);
    }

    if (orderTag) {
      orderTag.unmount();
    }

    landRegistryStore.off(landRegistryEvents.SET_ORDER_REFERENCE, setReference);
  });
};
